import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import {bookingFormCommon} from './c005-bookingform-common';

export class GstIndia{
	private $scope:any = $('.gst-form--container');
	private $gstEmail: string = '';
	private $gstError:Array<string> = [];
	private $gstSalutionEle: any;
	private bookingformcommon:any = new bookingFormCommon();

	validateEmail($gstEmail:string){
		let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
				return emailReg.test($gstEmail);
	}

	selectizeComponent(): any{
		let _self = this;
		_self.$gstSalutionEle = $('.gst-salution').html();
		$('.gst-salution').selectize({
			selectOnTab: true
		});

	 let $gstState:any = $('#gst-state').selectize({
			onFocus: function() {
				_self.$scope.find('.gst-state .form-title').addClass('input-filled');
				_self.$scope.find('.gst-state .selectize-control.single .selectize-input').addClass('select-filled');
				$('select.checkin-eticket--departure').parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$('select.checkin-eticket--departure').parent().find('.form-title').removeClass('has-error');
			},
			onChange: function() {
					_self.$scope.find('.gst-state .form-title').addClass('input-filled');
					_self.$scope.find('.gst-state .selectize-control.single .selectize-input').addClass('select-filled');
			},
			selectOnTab: true
		});
		$gstState[0].selectize.setValue('1');
	}

	initFieldFocusValidation(): void {
		let _self = this;

		// scope the form handler since this class is too generic and used in other forms as well
		// unbind past events before binding again
		_self.$scope.find('.form-validate')
		.off('focus','input')
		.on('focus','input', function(){
			let $this:any = $(this);
			$this.addClass('input-focused').removeClass('has-error');
			$('.form-title',$this.parent()).addClass('input-filled').removeClass('has-error');
		})
		.off('blur','input')
		.on('blur','input', function(){
			let $this:any = $(this);
			if ($this.val() == '') {
				$this.removeClass('input-focused');
				$('.form-title',$this.parent()).removeClass('input-filled');
			}
			else {
				$this.addClass('input-focused');
				$('.form-title',$this.parent()).addClass('input-filled');
			}
		})
		.off('click','.form-title')
		.on('click','.form-title', function(){
			let $this:any = $(this);
			$this.addClass('input-filled');
			$('input',$this.parent).addClass('input-focused');
		});

		// toggle terms and conditions box
		_self.$scope.find('.terms-and-conditons h3').off('click').on('click', function(){
			$('.tc-content').toggle();
		});

		// init validation handlers again
		_self.bookingformcommon.formFieldValidator();

		// custom pnr validator
		_self.$scope.find('.pnr-validator').keyup(function (e: any) {
			if (this.value.match(/[^a-zA-Z0-9 ]/g)) {
					this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '');
			}
		});
	}

	gstForm(): any{
		let _self = this;
		_self.initFieldFocusValidation();
		let tooltipmessage:string = '<div><p>Failure to provide a valid GST ID would result in no GST Tax Invoice being generated.</p></div>';		
		$('.info-icon').tooltip({content: tooltipmessage, track:true, tooltipClass:'tooltip-content'});			
		_self.$scope.find('#gst-btn').click((evt:any) => {
				evt.preventDefault();
				let self: any = this;
				let $gstEmailInput   : any = $('#gst-email');
				let $gstEmail        : any = $gstEmailInput.val();
				let $gstFirstname    : any = $('.name-validator.firstname');
				let $gstLastname     : any = $('.name-validator.lastname');
				let $gstPNR          : any = $('.PNR');
				let $gstTicketno     : any = $('.num-validator.ticketno');
				let $gstContactno    : any = $('#gst-contactno');
				let $gstCompanyname  : any = $('#gst-companyname');
				let $gstid   		 : any = $('#gst-gstid');
				let $gstCompanypan   : any = $('#gst-companypan');
				let $gstAddressOne   : any = $('#gst-Address1');
				let $gstCity         : any = $('#gst-city');
				let $gstCountry      : any = $('#gst-country');
				let $gstPincode      : any = $('#gst-pincode');
				let $gstValidator    : any = $('#gst-validator');
				let $gstErrorDiv     : any = $('.gst-error--validation');
				let $validationSuccess    : any = true;
				self.$gstError = [];
				/** validate first name input */
				$gstFirstname.each(function(i:number, target:any){
					let $GstFirstNameValidate: any = $('.gst-firstname>.name-validator');
					if($(this).val() == ''){
						let $gstFirstNameValidate = $(this).attr('data-firstname');
						self.$gstError.push('<strong>First Name:</strong> '+$gstFirstNameValidate + ' (#' + (i + 1) + ')');
						$(this).addClass('has-error');
						$(this).parent().find('.form-title').addClass('has-error');
						$validationSuccess = false;
					} else{
						$(this).removeClass('has-error');
						$(this).parent().find('.form-title').removeClass('has-error');
					}
				});

				/** validate last name input */
				$gstLastname.each(function(i:number, target:any){
					let $GstLastNameValidate: any = $('.gst-lastname>.name-validator');
					if($(this).val() == '' || $(this).val().length < 2){
						let $gstLastNameValidate = $(this).attr('data-lastname');
						self.$gstError.push('<strong>Last Name:</strong> '+$gstLastNameValidate + ' (#' + (i + 1) + ')');
						$(this).addClass('has-error');
						$(this).parent().find('.form-title').addClass('has-error');
						$validationSuccess = false;
					} else{
						$(this).removeClass('has-error');
						$(this).parent().find('.form-title').removeClass('has-error');
					}
				});

				/** validate PNR input */
				$gstPNR.each(function(i:number, target:any){
					let $gstPNRValidate: any = $('.gst-PNR>.name-validator');
					if($(this).val() == '' || $(this).val().length < 6){
						let $gstpnrValidate = $(this).attr('data-pnr');
						self.$gstError.push('<strong>PNR:</strong> '+$gstpnrValidate + ' (#' + (i + 1) + ')');
						$(this).addClass('has-error');
						$(this).parent().find('.form-title').addClass('has-error');
						$validationSuccess = false;
					} else{
						$(this).removeClass('has-error');
						$(this).parent().find('.form-title').removeClass('has-error');
					}
				});

				/** validate Ticket input */
				$gstTicketno.each(function(i:number, target:any){
					let $gstTicketnoValidate: any = $('.gst-ticketno>.name-validator');
					if($(this).val() == '' || $(this).val().length < 13){
						let $gstticketnoValidate = $(this).attr('data-ticketno');
						self.$gstError.push('<strong>Ticket number:</strong> '+$gstticketnoValidate + ' (#' + (i + 1) + ')');
						$(this).addClass('has-error');
						$(this).parent().find('.form-title').addClass('has-error');
						$validationSuccess = false;
					} else{
						$(this).removeClass('has-error');
						$(this).parent().find('.form-title').removeClass('has-error');
					}
				});

				/** validate Company name */
				if($gstCompanyname.val() == ''){
					let $gstCompanynameValidate:any = $gstCompanyname.attr('data-companyname');
					self.$gstError.push('<strong>Company Name:</strong> '+$gstCompanynameValidate);
					$gstCompanyname.addClass('has-error');
					$gstCompanyname.parent().find('.form-title').addClass('has-error');
					$validationSuccess = false;
				} else{
					$gstCompanyname.removeClass('has-error');
					$gstCompanyname.parent().find('.form-title').removeClass('has-error');
				}
				/** validate Company gst id */
				if($gstid.val() == ''){
					let $gstidValidate:any = $gstid.attr('data-gstid');
					self.$gstError.push('<strong>Company GST ID:</strong> '+$gstidValidate);
					$gstid.addClass('has-error');
					$gstid.parent().find('.form-title').addClass('has-error');
					$validationSuccess = false;
				} else{
					$gstid.removeClass('has-error');
					$gstid.parent().find('.form-title').removeClass('has-error');
				}

				/** validate Company PAN */
				if($gstCompanypan.val() == ''){
					let $gstCompanypanValidate:any = $gstCompanypan.attr('data-companypan');
					self.$gstError.push('<strong>Company PAN:</strong> '+$gstCompanypanValidate);
					$gstCompanypan.addClass('has-error');
					$gstCompanypan.parent().find('.form-title').addClass('has-error');
					$validationSuccess = false;
				} else{
					$gstCompanypan.removeClass('has-error');
					$gstCompanypan.parent().find('.form-title').removeClass('has-error');
				}
			
				if($gstCompanypan.val() != ''){
					let pancard = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
					if(pancard.test($gstCompanypan.val())==false){				
						let $gstCompanypanValidate:any = $gstCompanypan.attr('data-companypan');
						self.$gstError.push('<strong>Company PAN:</strong> '+$gstCompanypanValidate);
						$gstCompanypan.addClass('has-error');
						$gstCompanypan.parent().find('.form-title').addClass('has-error');
						$validationSuccess = false;
					} else{
						$gstCompanypan.removeClass('has-error');
						$gstCompanypan.parent().find('.form-title').removeClass('has-error');
					}
				}

				/** validate Address */
				if($gstAddressOne.val() == ''){
					let $gstAddressOneValidate:any = $gstAddressOne.attr('data-address1');
					self.$gstError.push('<strong>Address:</strong> '+$gstAddressOneValidate);
					$gstAddressOne.addClass('has-error');
					$gstAddressOne.parent().find('.form-title').addClass('has-error');
					$validationSuccess = false;
				} else{
					$gstAddressOne.removeClass('has-error');
					$gstAddressOne.parent().find('.form-title').removeClass('has-error');
				}

				/** validate City */
				if($gstCity.val() == ''){
					let $gstCityValidate:any = $gstCity.attr('data-city');
					self.$gstError.push('<strong>City:</strong> '+$gstCityValidate);
					$gstCity.addClass('has-error');
					$gstCity.parent().find('.form-title').addClass('has-error');
					$validationSuccess = false;
				} else{
					$gstCity.removeClass('has-error');
					$gstCity.parent().find('.form-title').removeClass('has-error');
				}

				/** validate Country */
				if($gstCountry.val() == ''){
					let $gstCountryValidate:any = $gstCountry.attr('data-country');
					self.$gstError.push('<strong>Country:</strong> '+$gstCountryValidate);
					$gstCountry.addClass('has-error');
					$gstCountry.parent().find('.form-title').addClass('has-error');
					$validationSuccess = false;
				} else{
					$gstCountry.removeClass('has-error');
					$gstCountry.parent().find('.form-title').removeClass('has-error');
				}
				
				if($gstPincode.val() != ''){
					let pincode = /^[1-9][0-9]{5}$/;
					if(pincode.test($gstPincode.val())==false){				
						let $gstPincodeValidate:any = $gstPincode.attr('data-pincode');
						self.$gstError.push('<strong>Postal code:</strong> '+$gstPincodeValidate);
						$gstPincode.addClass('has-error');
						$gstPincode.parent().find('.form-title').addClass('has-error');
						$validationSuccess = false;
					} else{
						$gstPincode.removeClass('has-error');
						$gstPincode.parent().find('.form-title').removeClass('has-error');
					}
				}
				/** validate pincode */
				if($gstPincode.val() == ''){
					let $gstPincodeValidate:any = $gstPincode.attr('data-pincode');
					self.$gstError.push('<strong>Postal code:</strong> '+$gstPincodeValidate);
					$gstPincode.addClass('has-error');
					$gstPincode.parent().find('.form-title').addClass('has-error');
					$validationSuccess = false;
				} else{
					$gstPincode.removeClass('has-error');
					$gstPincode.parent().find('.form-title').removeClass('has-error');
				}	
        /** validate City */
        // if ($gstAddressOne.val() == '') {
        //     let $gstAddressOneValidate:any = $gstAddressOne.attr('data-address1');
        //     self.$gstError.push($gstAddressOneValidate);
        //     $gstAddressOne.addClass('has-error');
        //     $gstAddressOne.parent().find('.form-title').addClass('has-error');
        //     $validationSuccess = false;
        // }
        // else {
        //     $gstAddressOne.removeClass('has-error');
        //     $gstAddressOne.parent().find('.form-title').removeClass('has-error');
        // }

				/** validate email address */
				if((!(this.validateEmail($gstEmail))) || $gstEmail == ''){
					let $gstEmailValidate:any = $gstEmailInput.attr('data-email');
					self.$gstError.push('<strong>Email Address:</strong> '+$gstEmailValidate);
					$gstEmailInput.addClass('has-error');
					$gstEmailInput.parent().find('.form-title').addClass('has-error');
					$validationSuccess = false;
				} else{
					$gstEmailInput.removeClass('has-error');
					$gstEmailInput.parent().find('.form-title').removeClass('has-error');
				}

				/** validate contact no. */
				if($gstContactno.val() == ''){
					let $gstContactnoValidate:any = $gstContactno.attr('data-contactno');
					self.$gstError.push('<strong>Contact Number:</strong> '+$gstContactnoValidate);
					$gstContactno.addClass('has-error');
					$gstContactno.parent().find('.form-title').addClass('has-error');
					$validationSuccess = false;
				} else{
					$gstContactno.removeClass('has-error');
					$gstContactno.parent().find('.form-title').removeClass('has-error');
				}
				if((self.$gstError).length > 0){
					$gstErrorDiv.show();
				}
				else{
					$gstErrorDiv.hide();
				}				
				let $validationContainer:any = $gstValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
				let $validationMessagelist:any = $validationContainer;

				for (var i = 0, len = this.$gstError.length; i < len; i++) {
					$validationMessagelist.append('<li data-id="'+i+'">' + this.$gstError[i] + '</li>');
				}
				$('html, body').animate({ scrollTop: '300px' });

				if($validationSuccess) {
					$.ajax({
						type: 'POST',
						url: 	'/bin/services/new/gstdatasaver',
						data:	$("#form").serialize(),
						success: function(msg:any){
							$gstErrorDiv.hide();
							$('.form-success').show();
							$('.gst-form--content').hide();
						},
						error: function(error:any) {
							let errMsg:any = $("#form").attr("data-errmsg");
							$gstErrorDiv.show();
							$("#gst-validator").html(errMsg);
							$('.form-success').hide();
							$('.gst-form--content').show();
						}
					});
				}
		});
	}

	gstAddPassengers(): any{
		let $maxNumberOfPersons:number = 12;
		let $addMoreSalution:any = 1;
		let _self = this;
		_self.$scope.find("#add-more--names").on("click", ".remove-passenger", function(e: any) {
			e.preventDefault();
			$(this).closest(".passenger-name").remove();
			$('#addMoreNames').css('opacity', 1);
		});

		_self.$scope.find("#addMoreNames").click(function(e: any) {
			e.preventDefault();
			if ($("div.passenger-name").length < $maxNumberOfPersons) {
				console.log('test');
				let $addNewPassengar = $(".passenger-name:first").clone();
				let $getPNR: any = $('.pnr-validator').val();
				$addNewPassengar.addClass("row-names");
				$addNewPassengar.find("input").val("");
				$addNewPassengar.find("input.pnr-validator").val($getPNR);
				$addNewPassengar.find(".remove-passenger").show();
				$("#add-more--names").append($addNewPassengar);
				$addMoreSalution++;
				let $gstSalution:any = $('#add-more--names select.gst-salution').last();
				let $gstSalutionSelectize:any = $('#add-more--names .selectize-control.gst-salution').last();
				$gstSalutionSelectize.remove();
				$gstSalution.removeClass('selectized');
				$gstSalution.css('display', '');
				$gstSalution.html(_self.$gstSalutionEle);
				$gstSalution.attr('id', 'gst-salution'+$addMoreSalution);
			} else {
				$(this).css('opacity', 0.5);
			}
			_self.$scope.find('#gst-salution'+$addMoreSalution).selectize({
				selectOnTab: true
			});
			_self.initFieldFocusValidation();
		});
	}
}

let scope:Element = document.querySelector('.gst-form--container');
if (scope){
	try {
		let gstindia = new GstIndia();
		gstindia.gstForm();
		gstindia.gstAddPassengers();
		gstindia.selectizeComponent();
	} catch(e) {console.error(e);}
}
